<!--
 * @Description: 关于我们
 * @Date: 2019-10-29 10:21:46
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-11-04 11:18:30
 -->

<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span>  </span>
          <v-spacer></v-spacer>
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="()=>{dialog = false}">
                <v-icon>close</v-icon>
              </v-btn>
            </template>
            <!-- <v-list>
              <v-list-item v-for="(item, i) in 5" :key="i" @click="() => {}">
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item>
            </v-list> -->
          </v-menu>
        </v-card-title>
        <v-card-text class="black--text">

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-subtitle>
                <img src="../../assets/me_us_logo@3x.png" alt="" class="hisens__">
              </v-list-item-subtitle>
              <p>{{ `硬汉邦（医生PC版）` }}</p>
            </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
            <v-list-item-content>
              <p>
                硬汉邦(患者版) - 是一款专注男性阴茎勃起功能检测(简称ED)的专业移动医疗软件。
              </p>
              <p></p>
              <p>
                该软件由顶级医学专家团队倾力打造，集疾病快速检测分析、名医全程跟踪治疗诊断于一体，快速进行医患数据化沟通，让治疗更精准高效，让患者早日康复！
              </p>
            </v-list-item-content>
            </v-list-item>

             <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-subtitle>
                客服热线
              </v-list-item-subtitle>
              <p>{{ `0755-33158961` }}</p>
            </v-list-item-content>
            </v-list-item>

        </v-card-text>
        <v-card-actions>
          <!-- <v-btn color="primary" text @click="dialog = false">Close</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    info(state) {
      this.dialog = state;
    }
  }
};
</script>
<style lang="scss" scoped>
.hisens__{
  width: 70px;
}
</style>
